import { useEffect, useState } from "react";
import styled from "styled-components";

export default function Switch({ list ,activeIndex = 0,onChange=() => {}}) {
  const [active,setActive] = useState(activeIndex)
  useEffect(() => {
    setActive(Number(activeIndex))
  },[activeIndex])
  return (
    <Wrapper>
      {list.map((e,i) => (
        <Item key={e.id} width={(100/list.length).toFixed(2)+'%'}  active={active === i} onClick={() => {
          setActive(i)
          onChange(i)
        }}>{e.name}</Item>
      ))}
      <Active width={(100/list.length).toFixed(2)+'%'} left={active ? 'calc('+(100/list.length).toFixed(2) * active+'% - 2px)': 0}></Active>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  text-align: center;
  background: #f4f5f6;
  position: relative;
`;
const Item = styled.div`
  position: relative;
  z-index: 10;
  width: ${props => props.width};
  flex: 0.5;
  font-style: normal;
  font-weight: 600;
  font-size: 1.3rem;
  line-height: 1.5rem;
  position: relative;
  transition: color 500ms;
  color: ${(props) => (props.active ? "#FFFFFF" : "#969696")};
  border-top:  1px solid #000000;
  border-bottom: 1px solid #000000;

  padding: .8rem 0;
  :first-child {
    border-left:  1px solid #000000;
    border-top-left-radius: 3.2rem;
    border-bottom-left-radius: 3.2rem;
  }
  :last-of-type {
    border-right:  1px solid #000000;
    border-top-right-radius: 3.2rem;
    border-bottom-right-radius: 3.2rem;
  }
`;

const Active = styled.span`
  transition: left 500ms;
  position: absolute;
  z-index: 5;
  left: ${props => props.left || 0};
  top:0;
  bottom: 0;
  width: ${props => props.width};
  background: #FC7B2B;
  border: 1px solid #000000;
  border-radius: 3.2rem;
  box-shadow: 2px 2px .0rem #000;
`;
